const localeViewPt = {
  pt: {
    CREHANA_FOR_BUSINESS: 'Crehana para empresas',

    SEO_DESCRIPTION:
      'Desenhamos treinamentos ágeis com profissionais do Google, Facebook, Amazon e outros. Melhore as habilidades de sua equipe em design, dados, transformação digital, softskills e muito mais.',

    HERO_BANNER_BUTTON: 'Comece seu teste gratuito',

    TERMS_1: 'Solicitando a demonstração, aceito',
    TERMS_2: 'termos e condições',
    TERMS_3: 'de Crehana',

    FREE_TRIAL_BANNER_TITLE: 'Acreditar na sua equipe é ajudá-la a crescer',
    FREE_TRIAL_BANNER_DESCRIPTION:
      'Treine sua equipe de forma interativa e próxima em nosso ecossistema de aprendizagem digital.',
    FREE_TRIAL_BANNER_BUTTON: 'Comece seu teste gratuito',

    ABOUT_SECTION__FEATURE_TITLE_1:
      'Nossos cursos estão disponíveis a qualquer momento.',
    ABOUT_SECTION__FEATURE_TITLE_2:
      'Acesse estatísticas em tempo real para ver o progresso de sua equipe.',
    ABOUT_SECTION__FEATURE_TITLE_3:
      'Aprenda com mentores especialistas do setor.',

    BANNER_SECTION_FORM_EMAIL: 'Email',
    BANNER_SECTION_FORM_EMAIL_ERROR: 'Digite um e-mail válido',
    BANNER_SECTION_FORM_REQUIRED: 'Campo obrigatório',
    BANNER_SECTION_FORM_MAX_LENGTH: 'Máximo 50 caracteres',
    BANNER_SECTION_FORM_BUTTON: 'Começar',
    BANNER_SECTION_BENEFITS_1: 'Diagnostique sua equipe',
    BANNER_SECTION_BENEFITS_2: 'Análise em tempo real',
    BANNER_SECTION_BENEFITS_3: 'Desenvolva suas habilidades',
    BANNER_SECTION_WHATSAPP_BUTTON_1: 'Experimente gratuitamente',
    BANNER_SECTION_WHATSAPP_BUTTON_2: 'Escreva-nos',

    TRIAL_FORM_TITLE_1: 'para empresas',
    TRIAL_FORM_TITLE_2: 'Viva a experiência por 7 dias',
    TRIAL_FORM_PROGRESS: 'Crie sua conta: Etapa {{current}} de 3',
    TRIAL_FORM_FEATURE_TITLE: 'Viva a experiência por 7 dias',
    TRIAL_FORM_FEATURE_DESCRIPTION:
      'Preencha seu formulário para ativar seu teste gratuito 🎉',
    TRIAL_FORM_FEATURE_ITEM_1: 'Diagnostique sua equipe',
    TRIAL_FORM_FEATURE_ITEM_2: 'Análise em tempo real',
    TRIAL_FORM_FEATURE_ITEM_3: 'Desenvolva suas mortes',
    TRIAL_FORM_FEATURE_ITEM_4: 'Crie seu próprio conteúdo',
    TRIAL_FORM_REQUIRED: 'Campo obrigatório',
    TRIAL_FORM_MAX_LENGTH: 'Máximo de 70 caracteres',
    TRIAL_FORM_ERROR_EMAIL: 'Por favor, insira um e-mail válido',
    TRIAL_FORM_STEP_1_TITLE:
      'Veja como a Crehana pode ajudá-lo a desenvolver as habilidades e criar seu próprio conteúdo.',
    TRIAL_FORM_STEP_1_NAME: 'Nome',
    TRIAL_FORM_STEP_1_LASTNAME: 'Sobrenome',
    TRIAL_FORM_STEP_1_EMAIL: 'Correio corporativo',
    TRIAL_FORM_STEP_1_BUTTON: 'Continue',
    TRIAL_FORM_STEP_2_TITLE:
      'Centenas de empresas como a sua estão usando Crehana para negócios',
    TRIAL_FORM_STEP_2_COMPANY: 'Nome da empresa',
    TRIAL_FORM_STEP_2_EMPLOYEES: 'Número de funcionários',
    TRIAL_FORM_STEP_2_ROLE: 'Posição ou posição',
    TRIAL_FORM_STEP_2_BUTTON: 'Continue',
    TRIAL_FORM_STEP_3_TITLE:
      'Centenas de empresas como a sua estão usando Crehana para negócios',
    TRIAL_FORM_STEP_3_PHONE: 'Número de telefone',
    TRIAL_FORM_STEP_3_COUNTRY: 'País',
    TRIAL_FORM_STEP_3_BUTTON: 'Concluir',
    TRIAL_FORM_STEP_3_COUNTRY_1: 'Peru',
    TRIAL_FORM_STEP_3_COUNTRY_2: 'Argentina',
    TRIAL_FORM_STEP_3_COUNTRY_3: 'México',
    TRIAL_FORM_STEP_3_COUNTRY_4: 'Colômbia',
    TRIAL_FORM_STEP_3_COUNTRY_5: 'Espanha',
    TRIAL_FORM_STEP_3_COUNTRY_6: 'Chile',
    TRIAL_FORM_STEP_3_COUNTRY_7: 'Outros',
    TRIAL_FORM_STEP_4_TITLE: 'Muito obrigado por registrar \n seus dados!',
    TRIAL_FORM_STEP_4_SUBTITLE:
      'Estaremos nos comunicando com você \n em breve para que você possa viver esta experiência.',

    TRIAL_FORM_COMPANY_TESTIMONIAL_TITLE: 'Equipes que crescem conosco',
    TRIAL_FORM_TESTIMONIAL_SLIDER_TITLE_1:
      '“Minha maneira de ver o microlearning mudou”',
    TRIAL_FORM_TESTIMONIAL_SLIDER_DESCRIPTION_1:
      '“As aulas de Crehana mudaram minha perspectiva de microlearning, ao invés disso, eu chamaria de fragmentação visualmente ergonômica do conhecimento. Você pode ouvir facilmente por 50 minutos sem sentir.”',
    TRIAL_FORM_TESTIMONIAL_SLIDER_OCCUPATION_1:
      'Diretor Regional de Talento Humano na SURA Asset Management',
    TRIAL_FORM_TESTIMONIAL_SLIDER_TITLE_2:
      '“A experiência com Crehana foi excelente”',
    TRIAL_FORM_TESTIMONIAL_SLIDER_DESCRIPTION_2:
      '“Nossa experiência com a Crehana foi excelente. Não só pelo conteúdo da plataforma, mas também pelo contato e flexibilidade que nos deram para usar as licenças. Gostei muito dos cursos, o tempo de cada parte foi perfeito e acho que os exemplos e explicações foram muito bons. A plataforma é amigável, fácil de usar e intuitiva.”',
    TRIAL_FORM_TESTIMONIAL_SLIDER_OCCUPATION_2:
      'Coordenador de Aprendizagem da Entel Peru.',
    TRIAL_FORM_TESTIMONIAL_SLIDER_TITLE_3:
      '“Crehana é uma aliada para o nosso desenvolvimento”',
    TRIAL_FORM_TESTIMONIAL_SLIDER_DESCRIPTION_3:
      '“Estamos muito gratos pela oportunidade, nossos colaboradores a receberam com muito entusiasmo e motivação, pois os temas são muito bons, atuais e contribuem muito para o desenvolvimento de nossas pessoas. Do ponto de vista de RH, a Crehana é uma aliada estratégica para montar planos de desenvolvimento e treinamento, retenção de talentos, reconhecimento e incentivos”',
    TRIAL_FORM_TESTIMONIAL_SLIDER_OCCUPATION_3: 'Gerente de RH na Bioderma.',

    COMPANIES_SECTION_TITLE: 'Equipes que crescem conosco',

    SOCIAL_VALIDATION_TITLE_1: 'Empresas que \n confiam em nós',
    SOCIAL_VALIDATION_TITLE_2: 'Colaboradores \n aprendendo',
    SOCIAL_VALIDATION_TITLE_3: 'Cursos em nossos \n trilhas de aprendizagem',

    BENEFITS_TITLE_1: 'Integração do Microsoft Teams',
    BENEFITS_DESCRIPTION_1:
      'Tenha maior acessibilidade inserindo seus cursos a partir de sua conta do Microsoft Teams',
    BENEFITS_TITLE_2: 'Skill XP',
    BENEFITS_DESCRIPTION_2:
      'Identifique seu nível de conhecimento para aprimorar seu aprendizado e treinar no que você precisa.',
    BENEFITS_TITLE_3: 'Metodologia baseada em projeto',
    BENEFITS_DESCRIPTION_3:
      'Aprendizagem contínua e flexível para colocar suas novas habilidades em prática imediatamente.',

    PERFORMANCE_BUTTON: 'Saiba mais',

    LEARN_SECTION_FEATURE_1_NAME: 'Salas de aula',
    LEARN_SECTION_FEATURE_1_DESCRIPTION:
      'Envie seu próprio conteúdo e crie grupos para decidir quem pode ver os cursos de sua organização.',
    LEARN_SECTION_FEATURE_1_BUTOON: 'Saiba mais',
    LEARN_SECTION_FEATURE_2_NAME: 'Desenvolver',
    LEARN_SECTION_FEATURE_2_DESCRIPTION:
      'Seja adquirindo novas habilidades ou desenvolvendo as que já possuem, é aqui que as pessoas de sua equipe aprendem.',
    LEARN_SECTION_FEATURE_2_BUTOON: 'Saiba mais',

    SKILL_IQ_SECTION_TITLE: 'Habilidade IQ',
    SKILL_IQ_SECTION_BUTTON: 'Saiba mais',

    TRACK_SECTION_TITLE: 'NOSSO CAMINHO DE APRENDIZAGEM',
    TRACK_SECTION_SUBTITLE_1: 'Aprender',
    TRACK_SECTION_SUBTITLE_2: 'de especialistas reconhecidos no mundo',
    TRACK_SECTION_BUTTON: 'Ver todas as rotas',
    TRACK_SECTION_TRACK_1_NAME: 'Vendas',
    TRACK_SECTION_TRACK_1_DESCRIPTION:
      'Gerencie seus clientes de forma eficiente e estratégica para melhores resultados. Dê aos seus clientes exatamente o que eles procuram e construa relacionamentos duradouros.',
    TRACK_SECTION_TRACK_1_BUTTON: 'Ver detalhes da rota',
    TRACK_SECTION_TRACK_1_OCCUPATION: 'Gerente de contas no Google',
    TRACK_SECTION_TRACK_1_TITLE: 'Software que você vai aprender',
    TRACK_SECTION_TRACK_2_NAME: 'Liderança',
    TRACK_SECTION_TRACK_2_DESCRIPTION:
      'Conheça as habilidades que um bom líder deve desenvolver para criar uma cultura de confiança e impulsionar o crescimento de sua equipe.',
    TRACK_SECTION_TRACK_2_BUTTON: 'Ver detalhes da rota',
    TRACK_SECTION_TRACK_2_OCCUPATION: 'Life and executive Coach',
    TRACK_SECTION_TRACK_2_TITLE: '',
    TRACK_SECTION_TRACK_3_NAME: 'Inovação',
    TRACK_SECTION_TRACK_3_DESCRIPTION:
      'Aprenda a implementar um projeto de inovação em seu trabalho, baseado no design de serviços e Design Thinking para conhecer seu usuário.',
    TRACK_SECTION_TRACK_3_BUTTON: 'Ver detalhes da rota',
    TRACK_SECTION_TRACK_3_OCCUPATION: 'Service Design & UX at Citibank',
    TRACK_SECTION_TRACK_3_TITLE: '',
    TRACK_SECTION_TRACK_4_NAME: 'Comércio eletrônico',
    TRACK_SECTION_TRACK_4_DESCRIPTION:
      'Crie suas próprias estratégias de vendas online, construa sua loja online e crie um novo canal para transformar seu negócio.',
    TRACK_SECTION_TRACK_4_BUTTON: 'Ver detalhes da rota',
    TRACK_SECTION_TRACK_4_OCCUPATION: 'Gerente de Produto Sr na Amazon',
    TRACK_SECTION_TRACK_4_TITLE: 'Software que você vai aprender',

    TESTIMONIAL_SECTION_1_TITLE: '“A experiência com a Crehana foi excelente”',
    TESTIMONIAL_SECTION_1_CONTENT:
      'Nossa experiência com a Crehana foi excelente. Não só pelo conteúdo da plataforma, mas também pelo contato e flexibilidade que nos deram para usar as licenças. Gostei muito dos cursos, o tempo de cada parte foi perfeito e acho que os exemplos e explicações foram muito bons. A plataforma é amigável, fácil de usar e intuitiva.',
    TESTIMONIAL_SECTION_1_OCCUPATION:
      'Coordenador de Aprendizagem da Entel Peru.',
    TESTIMONIAL_SECTION_2_TITLE: '"Minha maneira de ver o microlearning mudou"',
    TESTIMONIAL_SECTION_2_CONTENT:
      'As aulas de Crehana mudaram minha perspectiva de microlearning, ao invés disso, eu chamaria de fragmentação visualmente ergonômica do conhecimento. Você pode ouvir facilmente por 50 minutos sem sentir.',
    TESTIMONIAL_SECTION_2_OCCUPATION:
      'Diretor Regional de Talento Humano na SURA Asset Management',
    TESTIMONIAL_SECTION_3_TITLE:
      '"Crehana é uma aliada para o nosso desenvolvimento"',
    TESTIMONIAL_SECTION_3_CONTENT:
      'Agradecemos muito a oportunidade, nossos colaboradores a receberam com grande entusiasmo e motivação, pois os temas são muito bons, atuais e contribuem muito para o desenvolvimento de nossas pessoas. Do ponto de vista de RH, a Crehana é uma aliada estratégica para a construção de planos de desenvolvimento e treinamento, retenção de talentos, reconhecimento e incentivos.',
    TESTIMONIAL_SECTION_3_OCCUPATION: 'Gerente de RH da Bioderma.',

    BLOG_SECTION_TITLE_1: 'Conteúdo',
    BLOG_SECTION_TITLE_2: 'que acompanha o seu crescimento',
    BLOG_SECTION_BUTTON: 'Vá para o blog',

    VIDEO_SECTION_TITLE_HIGHLIGHT: 'Aprendendo juntos,',
    VIDEO_SECTION_TITLE: 'todos nós crescemos',
    VIDEO_SECTION_DESCRIPTION:
      'Crehana para empresas é um parceiro estratégico que ajuda sua organização a superar os desafios de aprendizagem e comunicação por meio da educação.',
    VIDEO_SECTION_BUTTON: 'Experimente gratuitamente',

    DOWNLOADABLE_CARD_DETAIL: 'Ver detalhes',
    DOWNLOADABLE_DOWNLOADS: 'downloads',

    SOCIAL_NOTIFICATION_TITLE: 'Entrou na Crehana!',
  },
};

export default localeViewPt;
